<div class="auth-layout-wrap">
    <div class="auth-content">
        <div class="card o-hidden">
            <div class="row">
                <div class="col-md-6">
                    <div class="p-4">
                        <div class="auth-logo text-center mb-4">
                            <h1 class="font-weight-bold text-28 primary-text">Welcome to EDMS</h1>
                        </div>
                        <ng-container *ngIf="state.formDOM === 'LOGIN'">
                            <h1 class="mb-3 text-22 text-center">Sign In</h1>
                            <form [formGroup]="loginFormGroup" (ngSubmit)="submit()" class="fade-in">
                                <div class="form-group">
                                    <label for="email">Email Address</label>
                                    <input class="form-control form-control-rounded" id="email" type="email" formControlName="email"
                                           [class.is-invalid]="loginFormGroup.get('email').invalid && loginFormGroup.get('email').touched">
                                    <div class="k-form-error" *ngIf="loginFormGroup.get('email').invalid &&
                                (loginFormGroup.get('email').touched || loginFormGroup.get('email').dirty)">
                                        <div *ngIf="loginFormGroup.get('email').hasError('required') ||
                                    loginFormGroup.get('email').hasError('whitespace')">
                                            Email Address is required
                                        </div>
                                        <div *ngIf="loginFormGroup.get('email').hasError('email')">
                                            Invalid Email Address
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="password">Password</label>
                                    <input class="form-control form-control-rounded" id="password" type="password" formControlName="password"
                                           [class.is-invalid]="loginFormGroup.get('password').invalid && loginFormGroup.get('password').touched">
                                    <div class="k-form-error" *ngIf="loginFormGroup.get('password').invalid &&
                                (loginFormGroup.get('password').touched || loginFormGroup.get('password').dirty)">
                                        <div *ngIf="loginFormGroup.get('password').hasError('required') ||
                                    loginFormGroup.get('password').hasError('whitespace')">
                                            Password is required
                                        </div>
                                        <div *ngIf="loginFormGroup.get('password').hasError('minlength')">
                                            Password must more than 6 characters
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-rounded btn-primary primary-btn btn-block mt-2" [disabled]="state.post" [class.k-loader--loading]="state.post">
                                    Sign In <span class="k-loader k-loader--light k-loader--right" *ngIf="state.post"></span>
                                </button>
                            </form>
                            <div class="mt-3 text-center">
                                <a class="text-muted" (click)="switchForms('FORGOT_PASSWORD')">
                                    <u>Forgot Password?</u>
                                </a>
                            </div>
                        </ng-container>
                        <ng-template [ngIf]="state.formDOM === 'FORGOT_PASSWORD'">
                            <app-reset-password (switchDom)="switchForms('LOGIN')"></app-reset-password>
                        </ng-template>

                        <ng-template [ngIf]="state.formDOM === 'CHANGE_PASSWORD'">
                            <app-update-password></app-update-password>
                        </ng-template>
                    </div>
                </div>
                <div class="col-md-6 text-center">
                    <div class="pr-3 auth-right">
                        <img src="assets/images/ministry_2.jpg" alt="logo-nis">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
